import { NavLink } from "react-router-dom";
import { Wordmark } from "./Wordmark";
import { FOOTER_LINKS } from "../lib/assets";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-aveden-black">
      <div className="gold-divider" />
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10 lg:px-16 py-20 lg:py-24">
        <div className="flex flex-col items-center text-center">
          {/* Brand */}
          <Wordmark size="lg" testId="footer-wordmark" />

          {/* Tagline */}
          <p className="font-sans text-[11px] tracking-[0.32em] uppercase text-aveden-gold/80 mt-10">
            Private Family Office
          </p>

          {/* Navigation */}
          <nav
            data-testid="footer-nav"
            className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-4"
          >
            {FOOTER_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                data-testid={`footer-nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="font-sans text-[12px] tracking-[0.2em] uppercase text-aveden-gray hover:text-aveden-white transition-colors duration-500"
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          {/* Divider */}
          <div className="mt-14 mb-10 h-px w-full max-w-xs bg-white/[0.08]" />

          {/* Bottom line */}
          <p className="font-sans text-[10px] tracking-[0.28em] uppercase text-aveden-gray/55">
            © 2026 AVEDEN. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
